import { Modal } from 'bootstrap'

export default function initModal() {
	if (document.querySelector('.modal')) {
		;[...document.querySelectorAll('.modal')].forEach((modalNode) => {
			new Modal(modalNode)
		})
	}
}